import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class GradesDTO {
  @ApiProperty()
  @IsNotEmpty({message:"gradeId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  gradeId: number;
  @ApiProperty()
  @IsNotEmpty({message:"gradeName should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  gradeName: string;
  @ApiProperty()
  @IsNotEmpty({message:"gradeMinCount should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  gradeMinCount: number;

  @ApiProperty()
//   @MaxLength(15, { message: "States Name allows maximum 15 characters" })
  @IsNotEmpty()
//   @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"States name should be only alpha numeric" })
  // @IsNotBlank('StatesName', { message: "States Name is not to be a white spaces" })
  gradeMaxCount: number;
  
  @ApiProperty()
  @IsNotEmpty()
  packCount: number;
  @ApiProperty()
  isActive: boolean;

  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;
}

